module.exports = __webpack_public_path__ + "img/index_tb.be9273ba.png";